export default __webpack_public_path__ + "static/media/folder.4fef29be.png";